var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { TitleStyle } from "./title-styles";
import { useTranslation } from "react-i18next";
export var Title = function (_a) {
    var title = _a.title;
    var t = useTranslation(['titles']).t;
    return (_jsx(React.Fragment, { children: _jsx(TitleStyle, __assign({ className: "page-header" }, { children: _jsx("h1", { children: t(title) }) })) }));
};
